import { Action } from 'redux';

import { SpaceType } from '~src/spacesPlatform/state/SpaceInfo';

import { PublishedConnectionTableCountsRequest } from '../../app/actions/AppActionTypes';

export interface PublishedConnectionTableCountsRequestAction extends Action {
  spaceType: SpaceType;
}

export function publishedConnectionTableCountsRequest(
  spaceType: SpaceType
): PublishedConnectionTableCountsRequestAction {
  return {
    type: PublishedConnectionTableCountsRequest,
    spaceType
  };
}
